import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import "@/styles/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_f225f10b-d8b4-4ffa-b240-0898e7a29d8d/artifacts/d1672wh9_LogoBlancoSinfondo-%20website.png" 
              alt="Pimot Construcciones" 
              className="footer-logo"
              data-testid="footer-logo"
            />
            <p className="footer-description">
              Construyendo espacios que mejoran vidas desde 2021.
            </p>
          </div>

          <div className="footer-section">
            <h3>Enlaces Rápidos</h3>
            <ul className="footer-links">
              <li><Link to="/" data-testid="footer-link-home">Inicio</Link></li>
              <li><Link to="/proyectos" data-testid="footer-link-projects">Proyectos</Link></li>
              <li><Link to="/servicios" data-testid="footer-link-services">Servicios</Link></li>
              <li><Link to="/contacto" data-testid="footer-link-contact">Contacto</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contacto</h3>
            <ul className="footer-contact">
              <li data-testid="footer-phone">
                <Phone size={18} />
                <span>829-993-0555</span>
              </li>
              <li data-testid="footer-email">
                <Mail size={18} />
                <span>info@pimot.com.do</span>
              </li>
              <li data-testid="footer-location">
                <MapPin size={18} />
                <span>República Dominicana</span>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Síguenos</h3>
            <div className="footer-social" data-testid="footer-social">
              <a href="#" aria-label="Facebook" data-testid="social-facebook">
                <Facebook size={20} />
              </a>
              <a href="#" aria-label="Instagram" data-testid="social-instagram">
                <Instagram size={20} />
              </a>
              <a href="#" aria-label="LinkedIn" data-testid="social-linkedin">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p data-testid="footer-copyright">
            © {currentYear} Pimot Construcciones. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;